import { render, staticRenderFns } from "./SpaceRoot.vue?vue&type=template&id=c0961766"
import script from "./SpaceRoot.vue?vue&type=script&lang=js"
export * from "./SpaceRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports